// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18oLK","image":"Header_image__2V5t3","name":"Header_name__kXw7v","info":"Header_info__1-Yoh","infoRow":"Header_infoRow__wokH_"};